'use client'

import React, {createContext, useContext, ReactNode} from 'react'

interface ApiUrlContextType {
  apiUrl: string
}

const ApiUrlContext = createContext<ApiUrlContextType | undefined>(undefined)

interface ApiUrlProviderProps {
  children: ReactNode
  apiUrl: string | undefined
}

export const ApiUrlProvider: React.FC<ApiUrlProviderProps> = ({children, apiUrl}) => {
  const contextValue: ApiUrlContextType = {
    apiUrl: apiUrl || 'http://localhost:8081'
  }

  return <ApiUrlContext.Provider value={contextValue}>{children}</ApiUrlContext.Provider>
}

export const useApiUrl = (): ApiUrlContextType => {
  const context = useContext(ApiUrlContext)
  if (!context) {
    throw new Error('useApiUrl must be used within an ApiUrlProvider')
  }
  return context
}
